@if (isAddUser()) {
  <div>
    <span class="clone-user txt-button" (click)="cloneUser()">{{
      'shared.copyUserRoleExistingUser' | translate | titlecase
    }}</span>
  </div>
}
<div class="permission-text flex-grid">
  <div class="col">
    <h4 class="section-hdr flt-left">{{ 'shared.locationPermissions' | translate | titlecase }}</h4>
  </div>

  <div class="col">
    <div class="add-location txt-button" (click)="openDialog()">
      <span class="flt-right add-icon-right">{{ 'shared.addLocation' | translate | titlecase }}</span>
      <mat-icon class="flt-right" svgIcon="add-icon"></mat-icon>
    </div>
  </div>
</div>

<table aria-hidden="true" cdk-table [dataSource]="locationPermissionsDataSource" class="responsive permission-table">
  <ng-container cdkColumnDef="globalRegion">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>
      {{ 'shared.globalRegion' | translate | titlecase }}
    </th>
    <td cdk-cell *cdkCellDef="let row">@if (row?.globalRegionVal) {
      <span></span>
    } {{ row.globalRegionVal }}</td>
  </ng-container>

  <ng-container cdkColumnDef="division">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>
      {{ 'shared.division' | translate | titlecase }}
    </th>
    <td cdk-cell *cdkCellDef="let row">@if (row?.divisionVal) {
      <span></span>
    } {{ row.divisionVal }}</td>
  </ng-container>

  <ng-container cdkColumnDef="country">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>{{ 'shared.country' | translate | titlecase }}</th>
    <td cdk-cell *cdkCellDef="let row">@if (row?.countryVal) {
      <span></span>
    }{{ row.countryVal }}</td>
  </ng-container>

  <ng-container cdkColumnDef="market">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>{{ 'shared.market' | translate | titlecase }}</th>
    <td cdk-cell *cdkCellDef="let row">
      {{ row.marketVal }}
    </td>
  </ng-container>

  <ng-container cdkColumnDef="submarket">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>
      {{ 'shared.submarket' | translate | titlecase }}
    </th>
    <td cdk-cell *cdkCellDef="let row">
      {{ row.subMarketVal }}
      @if (row.districtVal) {
        <span> - {{ row.districtVal }}</span>
      }
      @if (row.neighborhoodVal) {
        <span> - {{ row.neighborhoodVal }}</span>
      }
    </td>
  </ng-container>

  <ng-container cdkColumnDef="productType">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>
      {{ 'shared.productType' | translate | titlecase }}
    </th>
    <td cdk-cell *cdkCellDef="let row">{{ row.propertyUsageTypeVal }}</td>
  </ng-container>

  <ng-container cdkColumnDef="businessJustification">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>
      {{ 'shared.businessJustification' | translate | titlecase }}
    </th>
    <td cdk-cell *cdkCellDef="let row">
      <span>
        <mat-icon class="mat-business" matTooltip="{{ row.businessJustification }}">receipt</mat-icon>
      </span>
    </td>
  </ng-container>

  <ng-container cdkColumnDef="confidentiality" class="confidentiality-label">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>
      {{ 'shared.confidentiality' | translate | titlecase }}
      <mat-icon class="info-icon">info</mat-icon>
    </th>
    <td cdk-cell *cdkCellDef="let row">{{ row.confidentialityTypeVal }}</td>
  </ng-container>

  @if (pageType() !== 'user') {
    <ng-container cdkColumnDef="Approve/Reject">
      <th scope="col" cdk-header-cell *cdkHeaderCellDef>{{ 'shared.approveReject' | translate }}</th>
      <td cdk-cell *cdkCellDef="let row" class="locationper-radio">
        <mat-radio-group [(ngModel)]="row.accessRequestStatusId">
          <mat-radio-button [value]="1">{{ 'shared.approveLocation' | translate }}</mat-radio-button>
          <mat-radio-button [value]="2">{{ 'shared.rejectLocation' | translate }}</mat-radio-button>
        </mat-radio-group>
      </td>
    </ng-container>
  }

  <ng-container cdkColumnDef="buttons">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef></th>
    <td class="button-col-alg" cdk-cell *cdkCellDef="let row">
      @if (pageType() !== 'user' || requestMode()) {
        <button mat-icon-button (click)="edit(row)">
          <mat-icon [matTooltip]="'tooltip.edit' | translate" class="edit-mode">edit</mat-icon>
        </button>
      }

      @if ((row.accessRequestStatusId !== 3 || requestMode()) && !isPendingUser()) {
        <button
          mat-icon-button
          (click)="deletePermission(row.userId, row.id, row.rowId)"
          >
          <mat-icon [matTooltip]="'tooltip.delete' | translate" class="edit-mode" svgIcon="del-icon"></mat-icon>
        </button>
      }
    </td>
  </ng-container>

  <ng-container cdkColumnDef="status">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef></th>
    <td cdk-cell *cdkCellDef="let row">
      @if (row.accessRequestStatusId && row.accessRequestStatusId === 3 && !requestMode() && pageType() !== 'Admin') {
        <span
          class="pending-approval"
          >
          {{ 'shared.pendingRequestApproval' | translate }}
          <mat-icon>report_problem</mat-icon>
        </span>
      }
    </td>
  </ng-container>

  <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
  <tr cdk-row *cdkRowDef="let row; columns: displayedColumns"></tr>
</table>

@if (locationPermissions?.length === 0) {
  <div class="no-records-message">
    {{ 'shared.noPermissionsFound' | translate }}
  </div>
}
